module.exports = __webpack_public_path__ + "img/im_scrollfeature_09@2x.2e37c191.jpg";